export default __webpack_public_path__ + "static/media/Careers.39d1d506.jpg";